import Alert from "components/shared/common/alert";
import {
  setRoom,
  setEmoji,
  setSession,
  setSessionLink,
  setTeamChallenges
} from "redux/game/action";
import store from "redux/store";
import { setBuzzInfo } from "redux/game3/actions";
import { set_active_game } from "redux/sockets/action";
import { historyRef } from "routes";
import Socket from "socket/socket";

export const onMessageGetEventErrorAndData = (message) => {
  const parsedMessage = JSON.parse(message.data);
  const event = onMessageGetEvent(parsedMessage);
  const error = onMessageGetError(parsedMessage);
  const data = onMessageGetData(parsedMessage);
  return { event, error, data };
};

export const doObviousOnMessageActions = (event, data) => {
  switch (event) {
    case "challenge-get":
      store.dispatch(setTeamChallenges(data.team_challenges));
      break;
    case "ping":
      onPingActions(data);
      break;
    case "create_room":
      onCreateRoomActions(data);
      break;
    case "generate-session-url":
      onGenerateSessionUrlActions(data);
      break;
    case "send-emoji":
      onSendEmojiActions(data);
      break;
    case "buzz-vb":
      onBuzzVbActions(data);
      break;
    case "remove-user":
      onRemoveUserActions(data);
      break;
    case "end-game":
      onEndGameActions(data);
      break;
    default:
      break;
  }
  if (data?.room?.id) {
    if (data.room.active_game) {
      store.dispatch(setRoom(data));
      sessionStorage.setItem("roomId", data?.room?.id);
    } else {
      store.dispatch(set_active_game(false));
    }
  }
  if (data?.session) {
    if (data?.session?.valid) {
      store.dispatch(setSession(data.session));
    } else {
      store.dispatch(setSession({}));
      store.dispatch(setSessionLink(null));
    }
  }
};

const onPingActions = () => {
  const storeState = store.getStore().getState();
  const room = storeState?.gameReducer?.roomObj;
  if (room?.id) {
    const data = {
      action: "get-room",
      joinCode: room.join_code
    };
    Socket.sendMessage(data);
  }
};

const onCreateRoomActions = (data) =>
  store.dispatch(
    setRoom({ ...data, gameTiming: { lobbyStartTime: new Date() } })
  );

const onGenerateSessionUrlActions = (data) =>
  store.dispatch(setSessionLink({ ...data }));

const onSendEmojiActions = (data) => {
  if (data.action === "send-emoji") {
  } else {
    store.dispatch(setEmoji({ ...data }));
  }
  return setTimeout(() => {
    store.dispatch(setEmoji(""));
    clearTimeout();
  }, 2000);
};

const onBuzzVbActions = (data) =>
  store.dispatch(setBuzzInfo({ buzzInfo: { ...data } }));

const onRemoveUserActions = (data) =>
  Alert(200, `${data?.displayName} removed successfully`);

const onEndGameActions = async (data) => historyRef.current.push("/");

const onMessageGetEvent = (response) => {
  if (response?.message === "Buzzed") {
    return "buzz-vb";
  }
  if (response?.message === "PONG") {
    return "ping";
  }
  if (response?.emoji) {
    return "send-emoji";
  }
  if (response?.action) {
    return response?.action;
  }
  // if (response?.url) {
  //   return "generate-branch-url";
  // }
  if (response?.session_url) {
    return "generate-session-url";
  }
  if (response?.contacts) {
    return "zoom-contact-list";
  }
  if (response?.startUrl) {
    return "zoom-email-invite";
  }
  if (response?.event === "change-team-vb") {
    return "change-team-vb";
  }
  // if(response.action === "get-room"){
  //   return "get-room"
  // }
  // if(response.action === "join-game-host"){
  //   return "join-game-host"
  // }
  // if(response.action === "join-game-viewer"){
  //   return "join-game-viewer"
  // }
  return "others";
};

const onMessageGetError = (response) => response.error;

const onMessageGetData = (response) => response;
